import { usersUpdateAuthenticated } from 'api/endpoints/jelledFromFileSpecWithTransformer'
import { OnboardingStep } from 'api/model'
import { useActiveOrganization } from 'hooks/use-organization'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { authenticatedUserAtom, toastAtom } from 'state'

export type UpdateOnboardingStepOption = {
  onboardingStep?: OnboardingStep
  onboardingSteps?: OnboardingStep[]
}

const withOnboardingStep = (BaseComponent: any, _onboardingStep: OnboardingStep) => {
  return function EnhancedComponent(props: any) {
    const [activeOrganization] = useActiveOrganization()
    const [user, setUser] = useRecoilState(authenticatedUserAtom)
    const setToast = useSetRecoilState(toastAtom)

    // it is possible to pass a specific onboarding step to the HOC
    const updateOnboardingStep = async (steps?: UpdateOnboardingStepOption) => {
      if (!activeOrganization || !user) {
        return
      }

      try {
        let _steps = [_onboardingStep]
        if (steps?.onboardingStep) {
          _steps = [steps.onboardingStep]
        } else if (steps?.onboardingSteps) {
          _steps = steps.onboardingSteps
        }

        const userUpdate = {
          onboarding_steps_completed: [...user.onboarding_steps_completed, ..._steps],
        }

        const response = await usersUpdateAuthenticated(userUpdate)
        setUser((user) => {
          if (!user) {
            return null
          }

          return {
            ...user,
            onboarding_steps_completed: response.data.onboarding_steps_completed,
          }
        })
      } catch (err) {
        setToast({ title: 'Failed to update onboarding step', severity: 'error' })
      }
    }

    return <BaseComponent {...props} updateOnboardingStep={updateOnboardingStep} />
  }
}

export default withOnboardingStep
